import { floatingSurface } from '@/shared/styles/floatingSurface.styles'

export const tooltipStyles = {
  '&.MuiTooltip-tooltip': {
    ...floatingSurface,
    margin: '0.25rem 0 0 0 !important',
    padding: '0.75rem 0.5rem !important'
  }
}
